import axios from 'axios'

export default axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://dev-api.kafene.com/v1',
  crossdomain: true,
  timeout: 120000
})
